export default {
    clipboard: {
        copy_failed: 'Copy failed, please try again',
        no_content: 'There is no content to copy',
    },
    // 临时订单

    ptzhanghao: {
        bqgl: 'Label management',
        bqgl1: 'Generate order',
        bqgl2: 'platform',
        bqgl3: 'nation',
        bqgl4: 'shop',
        bqgl5: 'Order number',
        bqgl6: 'Delivery address',
        bqgl7: 'Order time',
        bqgl8: 'Pull time',
        bqgl9: 'SKU Pictures',
        bqgl10: 'Product name',
        bqgl11: 'Turn-in time',
        ls1: 'status',
        ls2: 'Temporary order',
        ls3: 'Cancelled',
        ls4: 'Cancel',
        a0: 'All order',
        a1: 'Temporary order',
        a2: 'Transferred order',
        a3: 'shopify',

        b3: 'Controls',





    },
    // 首页翻译
    home: {
        gglb1: 'List of announcements',
        gglb2: 'title',
        gglb3: 'Release time',
        gglb4: 'SKU warning',
        gglb5: 'Inventory management',
        gglb6: 'Order statistics',
        gglb7: 'Start date',
        gglb8: 'End date',
        gglb9: 'today',
        gglb10: 'yesterday',
        gglb11: 'Last 7 days',
        gglb12: 'Last 30 days',
        gglb13: 'all',
        gglb14: 'Financial information',
        gglb15: 'Available amount = balance',
        gglb16: 'Credit extension',
        gglb17: 'Temporary capacity',
        gglb18: 'Frozen',
        gglb19: 'Work order statistics',
        gglb20: 'Latest News',
        gglb21: 'More...',
        gglb22: 'Service ticket',
        gglb23: 'Wait for reply',
    },
    // 菜单翻译
    setyj: {
        kongzhitai: 'Console',
        guoneifahuo: 'Domestic Large Cargo',
        zxxb: 'Dedicated parcel',
        kuaididingdan: 'Express order',
        haiwaifahuo: 'Overseas shipments',
        caiwuzhongxin: 'Finance Center',
        syssettings: 'System settings',
        ptdr: 'Platform Management',

    },
    //二级翻译
    seterj: {
        dropshippingOrder: 'dropshippingOrder',
        transferOrder: 'transferOrder',
        gnlist: 'Order List',
        gnwaybill: 'Forecast order',
        gnpilsc: 'Batches',
        ddlist: 'Shipments',
        zlist: 'Order List',
        zwaybill: 'Forecast order',
        zpilsc: 'Batches',
        rcdgl: 'Warehouse order',
        waybill: 'New Shipment',
        pilsc: 'Batches',
        hwddlist: 'Order List',
        hwplsc: 'Batches',
        hwybdd: 'Forecast order',
        xjrk: 'Inventory management ',
        xjrk_zx: 'Full box inventory',

        rkjl: 'Inventory records',
        ddgl: 'Address management',
        caiwuls: 'Ainancial flows',
        dhzd: 'Bulk billing',
        qdjg: 'Channel price',
        gdlb: 'Ticket list',
        xtpz: 'System Configuration',
        ptgl: 'Platform Management',
        xbzd: 'Small packet billing',
        dscz: 'Warehouse Rental Reminder',
        skugl: 'SKU management',
        xstj: 'Sales Statistics',
        ddxg: 'Order related',
        ptzh: 'Platform account',
        skugx: 'SKU relationship',
        zcmd: 'Autobiographical sheet',
        hwsf: 'SCANFORM',
        kdsf: 'SCANFORM',
        lsddlb: 'Temporary Order',
        platform_shops: 'List of stores',
        platform_orders: 'Platform Order',
        kcdc: 'Inventory adjustment',
        rkjl_zx: 'Full container storage',


    },
    // 快递打单-预报订单
    kdyddd: {
        sj_name: ' Name',
        sj_tel: ' Phone',
        sj_gs: ' Company',
        sj_dizhi: ' Addres',
        sj_ycdizhi: ' Addres 2',
        sj_chengshi: ' City',
        sj_zouseng: ' State',
        sj_youbian: 'PostCode',
        sj_gj: ' Country',
        dd_bh: 'OrderID',
        sj_zdybz: 'Reference',
        insurance: 'Insured',
        sjxinxi: 'Receiving Information',
        orderSIZE: 'Order Settings',
        xzsl: 'Number of boxes',
        unitsize: 'Unit setting',
        xts: 'Tip:',
        xtswenzi: 'You can edit it in Excel, copy and paste it into the table below.',


    },
    // 快递打单-预报订单placeholder
    placeholder: {
        sj_name: 'Please enter the recipient name',
        sj_tel: 'Please enter the recipient phone number',
        sj_gs: 'Please enter the recipient company',
        sj_dizhi: 'Please enter the shipping address',
        sj_ycdizhi: 'Used when the address is too long',
        sj_chengshi: 'Please enter the recipient city',
        sj_zouseng: 'Please enter the recipient state or province',
        sj_youbian: 'Please enter the recipient postal code',
        sj_gj: 'Please select a country',
        dd_bh: 'Automatically generated when empty',
        sj_zdybz: 'Commonly used for notes on labels',
        insurance: 'Not insured for empty space (requires channel support)',
        dizhiku: 'Save to recipient address library',
        fbayundan: 'FBA waybill',
        xtzlcc: 'Same weight and size',
        xhws: 'Box number digits',




    },
    // 快递打单-批量上传
    kdpilsc: {
        pilisngTips: 'Single-ticket single-piece: upload by box quantity; one-ticket multi-piece: upload by box number',
        mobanTips: 'template',
        xzplmbTips: 'Download bulk templates',
        ddpcTips: 'Order Batch:',
        zlszTips: 'Weight setting:',
        scwjTips: 'Upload file:',
        ddnumTips: 'Order quantity:',
        sclistTips: 'Upload List',
        xitlistTips: '(Note: The system only retains 30 days of Excel import records!)',
        piliangTips: 'Batch Delete',
        pichiTips: 'batch',
        fileTips: 'file',
        ordernumTips: 'Order Quantity',
        successnumTips: 'Successful quantity',
        failnumTips: 'Number of failures',
        uptime1Tips: 'uploaded',
        caozuoTips: 'operate',
        Download_Batch_Template: 'Download Batch Template (Box Version)',//下载批量模板_箱号版
    },
    // 快递打单-订单列表
    kdlist: {
        gjz: 'keyword',
        gjzpay: 'Please enter keyword (order number/recipient/tracking number/Batch upload batch)',
        pi: 'batch',
        ysfs: 'Mode of transport',
        ysfspay: 'Please select a shipping method',
        zlfw: 'Weight range',
        zlfwpay: 'Please enter weight range (kg)',
        fjdz: 'Sending address',
        fjdzpay: 'Please enter the sending address ID',
        xuan: 'choose',
        cxfs: 'Query mode',
        cxfspay: 'Select the batch query mode',
        dorpay: 'Order number or tracking number batch query, one per line (this query only supports precise query, not fuzzy query)',
        kdcx: 'Express inquiry',
        all: 'All',
        ydy: 'printed',
        wdy: 'unprinted',
        sbdd: 'Failed order',
        wtk: 'No refund',
        ddk: 'To be refunded',
        ytk: 'Refunded',
        bntk: 'non-refundable',
        djz: 'frozen',
        rifw: 'Date range',
        ksrq: 'Start date',
        jsrq: 'End date',
        jr: 'today',
        zr: 'yesterday',
        jqr: 'Last 7 days',
        jssr: 'Last 30 days',
        hcdspt: 'Send back to the e-commerce platform',
        ysxc: '',
        tddxx: 'order information has been selected',
        sx: 'screen',
        cz: 'reset',
        hc0: 'To be returned',
        hc1: 'Returning',
        hc2: 'Successful return',
        hc3: 'Return failure',
        cx1: 'Not yet queried',
        cx2: 'Waiting for collection',
        cx3: 'In transit',
        cx4: 'Arrive for collection',
        cx5: 'Delivery failure',
        cx6: 'Possible exception',
        cx7: 'Sign successfully',
        ssjg: 'Trial price',
        sckdd: 'Generate express order',
        dyxtbq: 'Print system label',
        dyxtbq1: 'ZPl printing sheet',

        tswlpt: 'Push logistics platform',
        zzt: 'substate',
        mdxz: 'Sheet download',
        mdxz1: 'Merge download',
        mdxz2: ' Package download (by order number)',
        mdxz3: 'Package download (by tracking number)',
        mdxz4: 'Pack and download (by waybill number)',
        mdxz5: ' Pack and download (Order number @ Tracking number)',
        mdxz6: ' Pack and download (Label & Picking list)',
        mdxz7: ' Pack and download (Order number # Tracking number)',

        cjdd: 'Create an order',

    },
    // 海外发货-入库预报
    rukuyubao: {
        Inbound_Forecast: 'Inbound Forecast',//入库预报
        Select_Warehouse: 'Select Warehouse',//选择仓库
        Shipping_Method: 'Shipping Method',//运输方式
        Inbound_Remarks: 'Inbound Remarks',//入库备注
        Please_enter_remarks: 'Please enter remarks',//请输入备注信息
        Inbound_Details: 'Inbound Details',//入库详情
        Carton_Numbering_Rules: 'Carton Numbering Rules:',//箱号规则：
        Carton_numbers_should_use_digits: '1. Carton numbers should use digits (e.g., 1, 2, 3, 4). Different numbers indicate different cartons; identical numbers indicate the same carton.',//1、箱号建议以数字: 1、2、3、4
        // 表示，数字不同表示不同的箱子；相同的数字表示同一个箱子。
        Update_Inbound_Forecast: 'Update Inbound Forecast (Ctrl+S)',//更新入库预报(Ctrl+S)
        Submit_Inbound_Forecast: 'Submit Inbound Forecast (Ctrl+S)',//提交入库预报(Ctrl+S)
        Cancel: 'Cancel',//取消
        Insert_Row_Above: 'Insert Row Above',//上面插入一行
        Insert_Row_Below: 'Insert Row Below',//下面插入一行
        Insert_Row_Left: 'Insert Column Left',//左侧插入一列
        Insert_Column_Right: 'Insert Column Right',//右侧插入一列
        Remove_Row: 'Remove Row',//移除本行
        Remove_Column: 'Remove Column',//移除本列
        Alignment: 'Alignment',//对齐方式
        Read_Only: 'Read-Only',//只读
        Copy: 'Copy',//复制
        Cut: 'Cut',//剪切
        Clear_All_Cell_Data: 'Clear All Cell Data',//清空所有单元格数据
        Carton_No: 'Carton No',//箱号
        Quantity: 'Quantity',//数量
        one: 'one',//1
        Tracking_Number: 'Tracking Number',//跟踪号
        Please_select_a_warehouse: 'Please select a warehouse',//请选择仓库
        Please_select_a_shipping_method: 'Please select a shipping method',//请选择运输方式
        Maximum_entries_allowed: 'Maximum 300 entries allowed',//预报条数只能300条
        Batch_No_Carton_No_Container_No: ' Batch No/Carton No/Container No',//批次号/箱号/柜号
    },
    // 新增
    // 海外发货-库存调仓
    kcdcRun: {
        Source_Warehouse: 'Source Warehouse',//来源仓
        Destination_Warehouse: 'Destination Warehouse',//目的仓
        Transfer_Time: 'Transfer Time',//调仓时间
        Remarks: 'Remarks',//备注
        Details: 'Details',//详情
        Product_Name: 'Product Name',//产品名称
        Transfer_Quantity: 'Transfer Quantity',//调仓数量
        Pending: 'Pending',//待处理
        Processing: 'Processing',//处理中
        Dispatched: 'Dispatched',//已发出
        Completed: 'Completed',//已完成
    },
    // 海外发货-sku管理
    p_skugl: {
        Add_SKU_Mapping: 'Add SKU Mapping',//添加映射SKU
        SKU_List: 'SKU List',//SKU列表
        Mapped_SKU_List: 'Mapped SKU List',//映射SKU列表
        Bulk_Delete_Mapped_SKUs: 'Bulk Delete Mapped SKU',//批量删除映射SKU
        System_SKU: 'System SKU',//系统SKU      
        Creation_Time: 'Creation Time',//创建时间
        Shipping_Information: 'Shipping Information',//配送信息
        System_SKU_Quantity: 'System SKU / Quantity / Chinese Name / English Name / Remarks / Image',//系统sku/数量/中文名/英文名/备注/图片
        Quantity: 'Quantity',//数量
        Chinese_Name: 'Chinese Name',//中文名称
        English_Name: 'English Name',//英文名
        Image: 'Image',//图片
        Actions: 'Actions',//操作
        Map_SKU: 'Map SKU',//映射SKU
        Add_SKU: 'Add SKU',//添加SKU
        Keyword: 'Keyword',//关键字
        Please_enter_keyword: 'Please enter keyword (SKU, product name)',//请输入关键字(SKU,产品名称)
        Export_Data: 'Export Data',//导出数据
        Barcode: 'Barcode',//条形码
        Product_NameC: 'Product Name (Chinese)',//产品名称(中)
        Product_NameE: '	Product Name (English)',//产品名称(英)
        Dimensions: 'Dimensions (cm)',//长宽高(cm)
        Weight: 'Weight (kg)',//重量(kg)
        SKU_Declared_Value: 'SKU Declared Value',//SKU申报价值
        Contains_Battery: 'Contains Battery',//是否带电
        No: 'No',//否
        Yes: 'Yes',//是
        Product_Link: 'Product Link',//产品链接
        SKU_Image: 'SKU Image',//SKU图片
        Purchase_URL: 'Purchase URL',//采购网址
        Remarks: 'Remarks',//备注
        Forecast_Time: 'Forecast Time',//预报时间
        Color: 'Color',//颜色
        Sensitive_Item: 'Is Sensitive',//是否敏感
        Package_Shape: 'Packaging Shape',//外包装形状
        Irregular_Shape: 'Irregular Shape',//不规则形状
        Rectangular_Box: 'Cuboid',//长方体
        Cylinder: 'Cylinder',//圆柱体
        Package_Type: 'Packaging Type',//外包装类型
        Hard_Packaging: 'Hard Packaging',//硬包装
        Soft_PackagingH: 'Soft Packaging + Hard Items',//软包装+硬物
        Soft_PackagingS: 'Soft Packaging + Soft Items',//软包装+软物
        Sales_Link: 'Sales Link',//销售链接
        Manage: 'Manage',//管理
        Edit: 'Edit',//编辑
        Edit_SKU: 'Edit SKU',//编辑SKU
        Please_select: 'Please select if it contains a battery',//请选择是否带电
        Length: 'Length',//长
        Please_ente_product_lenght: 'Please enter product length',//请输入产品长
        Width: 'Width',//宽
        lease_enter_product_width: 'Please enter product width',//请输入产品宽
        Height: 'Height',//高
        Please_enter_product_height: 'Please enter product height',//请输入产品高
        Please_enter_product_link: 'Please enter product link',//请输入产品链接
        Please_enter_purchase_URL: 'Please enter purchase URL (must start with https:// or http://)',//请输入采购网址(请以https://或http://开头)
        Please_enter_remarks: 'Please enter remarks',//请输入备注
        Confirm_Edit: 'Confirm Edit (Ctrl+S)',//确认编辑(Ctrl+S)
        Cancel: 'Cancel',//取消
        Select_Template: 'Select Template',//选择模板
        Upload_File: 'Upload File',//上传文件
        Drag_file_here_or: 'Drag file here, or',//将文件拖到此处，或
        Click_to_Upload: 'Click to upload',//点击上传
        Only_Excel_files_allowed: '	Only Excel files allowed',//只能上传excel文件
        Max_limit_rows_in_xlsx_file: '(Max limit: 3000 rows in .xlsx file!)',//（最大限制3000行.xlsx文件!）
        If_the_mapped_SKU: 'If the mapped SKU is already bound, unbind and bind to the current system SKU?',//若映射SKU已被绑定过，是否解绑并与当前的系统SKU绑定？
        Confirm_Add: 'Confirm Add (Ctrl+S)',//确认添加(Ctrl+S)
        Delete: 'Delete',//删除
        Are_you_sure_to_delete: '	Are you sure you want to delete the last submitted mapped SKU?',//您确定要删除上一次提交映射的SKU吗?
        tip: 'Notification',//提示
        Confirm: 'Confirm',//确定
    },

    // 添加sku
    jilu_sku_add: {
        SKU: 'SKU',//SKU
        Add_SKU: 'Add SKU',//添加SKU
        Case_sensitivity_must_match: 'Note: Case sensitivity must match the database forecast',//注意大小写与入库预报一致
        Save: 'Save(Ctrl+S)',//保存(Ctrl+S)
        Cancel: 'Cancel',//取消
        Insert_Row_Above: 'Insert Row Above',//上面插入一行
        Insert_Row_Below: 'Insert Row Below',//下面插入一行
        Insert_Row_Left: 'Insert Column Left',//左侧插入一列
        Insert_Column_Right: 'Insert Column Right',//右侧插入一列
        Remove_Row: 'Remove Row',//移除本行
        Remove_Column: 'Remove Column',//移除本列
        Alignment: 'Alignment',//对齐方式
        Read_Only: 'Read-Only',//只读
        Copy: 'Copy',//复制
        Cut: 'Cut',//剪切
        Clear_All_Cell_Data: 'Clear All Cell Data',//清空所有单元格数据
        Cell_row: 'Cell row',//单元格第
        cell: 'cell',//行的
        Do_not_input_Chinese_characters: 'Do not input Chinese characters',//请不要输入中文字符
        No: 'No',//否
        Yes: 'Yes',//是
        Image_URL: 'Image URL',//图片url
        Product_Link: 'Product Link',//产品链接
        Product_Name: 'Product Name',//产品名称
        English_Name: 'English Name',//英文名称
        SKU_Declared_Value: 'SKU Declared Value',//SKU申报价值
        Single_Weight: 'Single Weight(kg)',//单件重(kg)
        Contains_Battery: 'Contains Battery',//是否带电
        Length: 'Length(cm)',//长(cm)
        Width: 'Width(cm)',//宽(cm)
        Height: 'Height(cm)',//高(cm)
        Non_sensitive: 'Non-sensitive',//不敏感
        Sensitive: 'Sensitive',//敏感
        Irregular_Shape: 'Irregular Shape',//不规则形状
        Rectangular_Box: 'Rectangular Prism',//长方体
        Cylinder: 'Cylinder',//圆柱体
        Hard_Packaging: 'Hard Packaging',//硬包装
        Soft_PackagingH: 'Soft Packaging + Hard Items',//软包装+硬物
        Soft_PackagingS: 'Soft Packaging + Soft Items',//软包装+软物
        Color: 'Color',//颜色
        Sensitive_Item: 'Is Sensitive',//是否敏感
        Package_Shape: 'Packaging Shape',//外包装形状
        Package_Type: 'Packaging Type',//外包装类型
        Sales_Link: 'Sales Link',//销售链接
        Please_enter_the_correct_SKU: 'Please enter the correct SKU',//请输入正确的SKU
    },
    // 新增订单列表
    hwddlilst: {
        Enable_Field: 'Enable Field',//启用字段
        Selected_fields_will_appear_in_the_Order_List: 'Selected fields will appear in the "Order List", while unselected ones will not. Enable or disable them based on business needs',//选中的字段将在“订单列表”展现，反之不展现，请根据业务情况开启或关闭
        Cancel: 'Cancel',//取 消
        OK: 'OK(Ctrl+S)',//确 定(Ctrl+S)
        Fields_displayed_in_the_template: 'Fields displayed in the template',//模板展示的字段
        Click_to_show: 'Click to show/hide, drag left/right to adjust column order',//点击设置显示或者隐藏，左右拖动设置列顺序
        Fields_not_displayed: 'Fields not displayed in the template',//模板不展示的字段
        Click_the_fiel_boxes_below: 'Click the field boxes below to add them to the displayed columns',//点击下方字段方块，转入到表格展示的字段
        Template_Name: 'Template Name',//模板名称
        Export_Template_Name: 'Export Template Name',//导出模板名称
        Sort: 'Sort',//排序
        Please_select: 'Please select',//请选择
        Sorting_Rule: 'Sorting Rule',//排序规则
        Confirm_Add: 'Confirm Add',//确认添加
        Confirm_Edit: 'Confirm Edit',//确认编辑
        Create_Order: 'Create Order',//创建订单
        Excel_Import: 'Excel Import',//Excel导入
        Keyword: 'Keyword',//关键字
        Please_enter_a_keyword: 'Please enter a keyword (Order No./Recipient/Tracking No./Batch Upload ID)',//请输入关键字(订单号/收件人/跟踪号/批量上传批次)
        batch: 'batch',//批
        Overseas_Warehouse: 'Overseas Warehouse',//海外仓库
        Enter_Warehouse: 'Enter Warehouse ID or select',//请输入仓库Id或者选择
        Select: 'Select',//选
        Shipping_Method: 'Shipping Method',//运输方式
        Please_select_shipping_method: 'Please select shipping method',//请选择运输方式
        Weight_Range: 'Weight Range',//重量范围
        Enter_weight_range: 'Enter weight range(kg)',//请输入重量范围(kg)
        Query_Method: 'Query Method',//查询方式
        Please_select_batch_query_method: 'Please select batch query method',//请选择批量查询方式
        Batch_query_by_Order_No: 'Batch query by Order No. or Tracking No., one per line (Exact match only, fuzzy search not supported)',//订单号或跟踪号批量查询，每行一个(该查询只支持精确查询，不支持模糊查询)
        Express_Query: 'Express Query',//快递查询
        All: 'All',//全部
        Printed: 'Printed',//已打印
        Unprinted: 'Unprinted',//未打印
        Failed_Orders: 'Failed Orders',//失败订单
        No_Refund: 'No Refund',//无退款
        Pending_Refund: 'Pending Refund',//待退款
        Refunded: 'Refunded',//已退款
        Non_refundable: 'Non-refundable',//不能退款
        Frozen: 'Frozen',//冻结中
        Check_Status: 'Check Status',//查询状态
        Sync_Back_to_commerce_Platform: 'Sync Back to E-commerce Platform',//回传电商平台
        Date_Range: 'Date Range',//日期范围
        Start_Date: 'Start Date',//开始日期
        End_Date: 'End Date',//结束日期
        Today: 'Today',//今日
        Yesterday: 'Yesterday',//昨日
        Last_7_Days: 'Last 7 Days',//近7日
        Last_30_Days: 'Last 30 Days',//近30日
        Additional_Charges: 'Additional Charges',//补扣费用
        Pending_Approval: 'Pending Approval',//未审批
        Approved: 'Approved',//已审批
        Filtered_out: 'Filtered out',//已筛选出
        order_records: 'order records',//条订单信息
        Filter: 'Filter',//筛选
        Reset: 'Reset',//重置
        Sub_status: 'Sub-status',//子状态
        Batch_Upload: 'Batch Upload',//批量上传
        Batch_Upload_Tracking_Numbers: 'Batch Upload Tracking Numbers',//批量上传跟踪号
        Batch_Upload_Labels: 'Batch Upload Labels',//批量上传Labels
        Pending_verification_orders: 'Pending verification orders may have inaccurate fees. The corresponding amount will be frozen for such orders, and the freeze will be lifted with actual charges applied after verification',//待核销属于费用可能存在不准确的订单，该类订单会被冻结相应的金额，核销后会取消冻结并真实扣费。
        Shipping_Label_Download: 'Shipping Label Download',//面单下载
        Merge_Download: 'Merge & Download',//合并下载
        Batch_DownloadO: 'Batch Download (by Order Number)',//打包下载(按订单号)
        Batch_DownloadT: 'Batch Download (by Tracking Number)',//打包下载(按跟踪号)
        Batch_DownloadW: 'Batch Download (by Waybill Number)',//打包下载(按运单号)
        Return_Tracking_Number: 'Return Tracking Number',//回传单号
        Confirm_Bill: 'Confirm Bill',//确认账单
        Select_Shipping_Channel: 'Select Shipping Channel',//选择快递渠道
        Please_Select_Sender_Address: 'Please Select Sender Address',//请选择发件地址
        Price_Estimation: 'Price Estimation',//试算价格
        Generate_Shipping_Label: 'Generate Shipping Label',//生成快递单
        Confirm_Shipment: 'Confirm Shipment',//确认发货
        Retrieve_Again: 'Retrieve Again',//重新获取
        Request_Refund: 'Request Refund',//申请退款
        Delete: 'Delete',//删除
        Column_Template_Settings: 'Column Template Settings',//列模板设置
        Export_Data: ' Data',//导出数据
        Add_Template: 'Add Template',//添加模板
        This_is_sample_content: 'This is sample content, this is sample content, this is sample content, this is sample content.',//这是一段内容,这是一段内容,这是一段内容,这是一段内容。
        Select_All_Orders_in_Current_Status: 'Select All Orders in Current Status',//勾选当前状态下全部订单
        Click_to_Copy: 'Click to Copy',//点击复制
        Postage_Fee: 'Postage Fee:',//邮费:
        Handling_Fee: 'Handling Fee:',//处理费:
        Registration_Fee: 'Registration Fee:',//挂号费:
        Other_Fees: 'Other Fees:',//其他费用:
        Fuel_Surcharge: 'Fuel Surcharge:',//燃油费:
        Unable_to_View_Orders: 'Unable to View Orders',//无法查看订单
        Processing_Orders: 'Processing Orders',//正在出单
        Request_in_Progress: 'Request in Progress',//请求中
        Upload: 'Upload',//上传
        Double_click_this_Row_for_Same_Effect: 'Double-click this Row for Same Effect',//双击本行同效
        Upload_Shipping_Label_and: 'Upload Shipping Label and Tracking Number for Shipment',//上传面单及跟踪号发货
        Order_Number: 'Order Number',//订单号
        Tracking_Number: 'Tracking Number',//跟踪号
        Please_Enter_Tracking_Number: 'Please Enter Tracking Number',//请输入跟踪号
        Upload_Shipping_Label: 'Upload Shipping Label',//上传面单
        Click_to_Upload: 'Click to Upload',//点击上传
        PDF_Files_Only: 'PDF Files Only',//只能上传PDF文件
        Confirm_Shipment: 'Confirm Shipment',//确认发货
        Generate: 'Generate SCANFORM',//生成SCANFORM
        OK1: 'ok',//确认
        Order_Quantity: 'Order Quantity',//订单数量
        Select_Status: 'Select Status',//选择状态
        Please_Select_Order_Status: 'Please Select Order Status',//请选择订单状态
        Solution: 'Solution',//解决方案
        Click_Here: 'Click Here',//点击此处
        Please_carefully_read_the_following_instructions: 'Please carefully read the following instructions:',//请认真阅读以下提示：
        Error_Tag: '1.Error Tag: "API Error", This error is returned by the interface (vendor) and requires contacting the vendor to resolve.',//1、报错标识：“接口报错”，该报错由接口（供应商）返回，需要联系供应商解决。
        Get_the_interaction: '2. Get the interaction JSON between ShipOS and your vendor',//获取 ShipOS 与 你们供应商 交互的JSON
        Sen_the_interaction: '3. Send the interaction JSON to the vendor for investigation and resolution',//3、将交互JSON发给供应商，由供应商查询解决
        Not_queried_yet: 'Not queried yet',//暂未查询
        No_results_found: 'No results found',//查询不到
        Awaiting_pickup: 'Awaiting pickup',//等待揽收
        In_transit: 'In transit',//运输途中
        Arrived_for_pickup: 'Arrived for pickup',//到达待取
        Delivery_failed: 'Delivery failed',//投递失败
        Potential_exception: 'Potential exception',//可能异常
        Successfully_delivered: 'Successfully delivered',//签收成功
        Excessive_transit_time: 'Excessive transit time',//运输过久
        This_week: 'This week',//本周
        This_month: 'This month',//本月
        Last_month: 'Last month',//上月
        Last_7_days1: 'Last 7 days',//最近一周
        Last_30_days2: 'Last 30 days',//最近一个月
        Last_90_days3: 'Last 90 days',//最近三个月
        Original_import_sequence: 'Original import sequence',//原导入顺序
        Order_ID: 'Order ID',//订单编号
        RemarksN: 'NoteRemarks',//Note备注
        Shipping_channel: 'Shipping channel',//运输渠道
        Ascending: 'Ascending',//升序
        Descending: 'Descending',//降序
        Close_search: 'Close search',//关闭搜索
        Test_Data: 'Test Data',//黄金糕
        Please_select_the_data_you_want: 'Please select the data you want to operate on',//请选择您要操作的数据
        This_action_will_approve_the_order: 'This action will approve the order. Continue?',//此操作将会审批该条订单,是否继续？
        Confirm_action: 'Confirm action',//确认操作
        This_will_select_all_orders_in_current_status: 'This will select all orders in current status. Continue?',//该操作会勾选当前状态下的所有订单，是否继续操作
        Confirmation: 'Confirmation',//确认信息
        All_orders_in_current_status_selected: 'All orders in current status selected',//已勾选当前状态下的全部订单
        Copied_successfully: 'Copied successfully',//复制成功
        Please_select_shipping_method: 'Please select shipping method',//请选择运输方式
        Please_select_status: 'Please select status',//请选择状态
        Error_message: 'Error message',//错误信息
        Maximum_one_file_allowed: 'Maximum one file allowed',//最多支持上传一个文件
        Only_pdf_files_allowed: 'Only .pdf files allowed',//只能上传后缀是.pdf的文件
        Please_upload_shipping_label: 'Please upload shipping label',//请上传面单
        Please_select_address: 'Please select address',//请选择地址
        Please_select_orders_for_refund_first: 'Please select orders for refund first',//请先选择要退款的订单
        This_will_submit_refund_request_Continue: 'This will submit refund request. Continue?',//此操作将会为您申请退款, 是否继续?
        Notification: 'Notification',//提示
        No_data_selected: 'No data selected',//您还未勾选数据
        File_read_error: 'File read error',//文件读取错误。
        please_reselect_or_contact_admin: 'File error, please reselect or contact admin',//文件错误,请重新选择或联系管理员
        This_action_cannot_be_undone: 'This action cannot be undone',//此操作将不可恢复
        Generating_waybill_will_charge_fees: 'Generating waybill will charge fees. Confirm?',//生成快递单将直接扣费，确认生成吗？
        Please_select_at_least_three_fields: 'Please select at least three fields',//请选择至少三个字段
        This_will_permanently_delete_the_template: 'This will permanently delete the template. Continue?',//此操作将永久删除该模板, 是否继续?
        Successfully_deleted: 'Successfully deleted',//删除成功
        Edit_template: 'Edit template',//编辑模板
        Close_search: 'Close search',//关闭搜索
        Enable_search: 'Enable search',//开启搜索
        Please_select_channel: 'Please select channel',//请选择渠道
        Price_estimation_completed: 'Price estimation completed',//试算价格已完成
        Action: 'Action',//操作
        Continue: 'Continue',//继续
        UI_Prompt: 'UI Prompt',//请选择订单
        Split_Order: 'Split Order',//拆分订单
    },
    //创建运单
    hwcarate_waybill: {
        Create_Shipping_Label: 'Create Shipping Label',//创建运单
        Select_Warehouse: 'Select Warehouse',//选择仓库
        Please_Select_Warehouse: 'Please Select Warehouse',//请选择仓库
        Quick: 'Quick',//快
        Efficient: 'Efficient',//捷
        Fill: 'Fill',//填
        Write: 'Write',//写
        As_a_Noun: 'As_a_Noun',//地
        Address: 'Address',//址
        Please_enter_exac_address_in_this_box: 'Please enter exact address in this box',//请在本框中输入精确地址，如示例
        Click_to_Parse_Address: 'Click to Parse Address',//点击分解地址
        Enter_full_address_in_left_box: 'Enter full address in left box, then click this button to auto-fill recipient fields below',// 在左框中输入完整地址，然后本按钮，自动分解地到到下方收件信息。
        Saved_Addresses: 'Saved Addresses',//常用地址
        Please_Select_Saved_Shipping_Address: 'Please Select Saved Shipping Address',//请选择常用收件地址
        FBA_Address: 'FBA Address',//FBA地址
        receiving_information: 'receiving information',//收件信息
        Please_Select_FBA_Address: 'Please Select FBA Address',//请选择FBA地址
        Quick_Fill_Close: 'Quick Fill Close',//快捷关闭填写
        Recipient_Information: 'Recipient Information',//
        FBA_warehouse_addresses_may_change: 'Note: FBA warehouse addresses may change. Verify auto-filled addresses for accuracy!',//因FBA仓库地址会有变更的情况，使用快捷填写需要自行确认录入的地址是否准确！
        Recipient_Name: 'Recipient Name',//收件姓名
        Please_Enter_Recipient_Name: 'Please Enter Recipient Name',//请输入收件姓名
        Recipient_Phone: 'Recipient Phone',//收件电话
        Please_Enter_Recipient_Phone: 'Please Enter Recipient Phone',//请输入收件电话
        Recipient_Company: 'Recipient Company',//收件公司
        Please_Enter_Recipient_Company: 'Please Enter Recipient Company',//请输入收件公司
        Recipient_Address: 'Recipient Address',//收件地址
        Please_Enter_Recipient_Address: 'Please Enter Recipient Address',//请输入收件地址
        Address_Line: 'Address Line 2 (Extended)',//延长地址
        Use_for_overflow_address_text: 'Use for overflow address text',//当前地址过长时使用
        City: 'City',//收件城市
        Please_Enter_City: 'Please Enter City',//请输入收件城市
        State_Province: 'State/Province',//收件州省
        Please_Enter_State_Province: 'Please Enter State/Province',//请输入收件州省
        Postal_Code: 'Postal Code',//收件邮编
        Please_Enter_Postal_Code: 'Please Enter Postal Code',//请输入收件邮编
        Destination_Country: 'Destination Country',//目的国家
        Please_Select_Country: 'Please Select Country',//请选择国家
        Select: 'Select',//选
        Order_Number: 'Order Number',//订单编号
        generate_when_empty: 'Auto-generate when empty',//为空时自动生成
        Custom_Remarks: 'Custom Remarks',//自定备注
        Mainly_used_for_label_notes: 'Mainly used for label notes',//多用于Label上的备注
        Save_to_Address_Book: 'Save to Address Book',//保存到收件地址库
        Order_Settings: 'Order Settings',//订单设置
        Number_of_Boxes: 'Number of Boxes',//箱子数量
        Same_Weight: 'Same Weight/Dimensions',//相同重量尺寸
        FBA_Shipment: 'FBA Shipment',//FBA运单
        Please_Enter: 'Please Enter',//请输入
        Box_Number_Digits: 'Box Number Digits',//箱号位数
        Please_Select: 'Please Select',//请选择
        Unit_Settings: 'Unit Settings',//单位设置
        Tip: 'Tip:',//小提示：
        You_can_edit_in_Excel_first: 'You can edit in Excel first, then copy & paste to the table below',//可以在Excel中编辑好，复制并粘贴到下方表格。
        Submit_Order: 'Submit Order(Ctrl+S)',//提交订单(Ctrl+S)
        Battery_Included: 'Battery Included',//带电
        Magnetic: 'Magnetic',//带磁
        mph: 'house number',//门牌号

        Hazardous_Materials: 'Hazardous Materials',//危险品
        Liquid: 'Liquid',//液体
        Powder: 'Powder',//粉末
        Paste: 'Paste',//膏体
        General_Goods: 'General Goods',//普货
        Sensitive_Goods: 'Sensitive Goods',//敏感货
        Wood_Products: 'Wood Products',//木制品
        Textiles: 'Textiles',//纺织品
        Enable_Quick_Fill: 'Enable Quick Fill',//开启快捷填写
        Insert_Row_Above: 'Insert Row Above',//上面插入一行
        Insert_Row_Below: 'Insert Row Below',//下面插入一行
        Insert_Column_Left: 'Insert Column Left',//左侧插入一列
        Insert_Column_Right: 'Insert Column Right',//右侧插入一列
        Delete_Row: 'Delete Row',//移除本行
        Delete_Column: 'Delete Column',//移除本列
        Alignment: 'Alignment',//对齐方式
        Read_only: 'Read-only',//只读
        Copy: 'Copy',//复制
        Cut: 'Cut',//剪切
        Clear_All_Cell_Data: 'Clear All Cell Data',//清空所有单元格数据
        Quantity: 'Quantity',//数量
        Auto_generate: 'Auto-generate',//自动生成
        Minimum_1_box_required: 'Minimum 1 box required',//箱子数量至少为1个
        Please_enter_name: 'Please enter name',//请填写姓名
        Please_enter_phone: 'Please enter phone',//请填写电话
        Please_enter_city: 'Please enter city',//请填写城市
        Please_enter_state_province: 'Please enter state/province',//请填写州省
        Please_enter_country: 'Please enter country',//请填写国家
        Please_enter_postal_code: 'Please enter postal code',//请填写邮编
        Please_fill_in_the_address: 'Please fill in the address',//请填写地址
    },
    // 批量上传
    hwpiliang: {
        Bulk_Upload: 'Bulk Upload',//批量上传
        This_feature_only_supports_single_piece_orders: 'This feature only supports single-piece orders. Multi-piece shipments cannot be bulk imported currently',//该功能仅适用于单票单件的订单，一票多件的订单暂时不能批量导入。
        Uploading_in_progress: 'Uploading in progress - do not refresh',//上传中，请勿刷新
        Excel_Template: 'Excel Template',//Excel模板
        Inventory_Shipping_Template: 'Inventory Shipping Template',//库存发货模板
        Batc_Number: 'Batch Number:',//订单批次：
        Auto_generate_if_empty: 'Auto-generate if empty',//为空时自动生成
        Warehouse_Matching: 'Warehouse Matching:',//匹配仓库：
        Not_Matched: 'Not Matched',//不匹配
        Matched: 'Matched',//匹配
        Select_Warehouse: 'Select Warehouse',//选择仓库
        Weight_Settings: 'Weight Settings:',//重量设置：
        Upload_File: '上传文件：',//上传文件：
        Drag_file_here_or: 'Drag file here or',//将文件拖到此处，或
        click_to_upload: 'click to upload',//点击上传
        Excel_files_only: 'Excel files only',//只能上传excel文件
        Max_3000_rows_in: '(Max 3,000 rows in .xlsx format!)',//（最大限制3000行.xlsx文件!）
        Order_Quantity: 'Order Quantity:',//订单数量：
        Upload_Excel: 'Upload Excel',//上传EXCEL
        Upload_History: 'Upload History',//上传列表
        System_only_retains_Excel_import: '(Note: System only retains Excel import records for 30 days!)',//( 注意:系统仅保留30天的Excel导入记录! )
        Bulk_Delete: 'Bulk Delete',//批量删除
        Module_Name: 'Module Name',//模块名称
        Batch: 'Batch',//批次
        Download: 'Download',//下载
        Order_Qty: 'Order Qty',//订单数量
        Success: 'Success',//成功数量
        Failed: 'Failed',//失败数量
        Upload_Time: 'Upload Time',//上传时间
        Action: 'Action',//操作
        Delete: 'Delete',//删除
        Please_select_data: 'Please select data',//请勾选数据
        This_action_cannot_be_undone: 'This action cannot be undone',//此操作将不可恢复
        Alert: 'Alert',//提示
        Confirm: 'Confirm',//确定
        Cancel: 'Cancel',//取消
        Deleted_successfully: 'Deleted successfully',//删除成功
        Deletion_failed: 'Deletion failed',//删除失败
        Data_older_than_30_days_has_been_purged: 'Data older than 30 days has been purged',//已清除30天以外的数据
        Invalid_format_Please_upload: 'Invalid format. Please upload .xls or .xlsx files',//上传格式不正确，请上传xls或者xlsx格式
        Please_select_warehouse: 'Please select warehouse',//请选择仓库
        Please_upload_file_first: 'Please upload file first',//请先上传文件
        File_cannot_exceed_3000_rows: 'File cannot exceed 3,000 rows',//上传文件不能超过3000行
        File: 'File'//文件
    },

    // 新增入库记录
    rukujilu: {
        SKU_Label_Configuration: 'SKU Label Configuration',//配置SKU标签
        Width: 'Width',//宽
        Height: 'Height',//高
        Top_Margin: 'Top Margin',//顶部距离
        Barcode_Top_Margin: 'Barcode Top Margin (Recommended range: 3-20)',//条形码距离顶部距离,建议范围3—20
        Barcode_Height: 'Barcode Height',//条形码高度
        Barcode_HeightR: 'Barcode Height (Recommended: 20)',//条形码的高度,建议20
        Barcode_Length: 'Barcode Length',//
        // 条形码长度
        Barcode_LengthR: 'Barcode Length (Recommended: 20)',//条形码的长度,建议20
        Cancel: 'Cancel',//取 消
        Confirm: 'Confirm',//确 定
        Edit: 'Edit',//编辑
        Product_Name: 'Product Name',//产品名称
        Product_SKU: 'Product SKU',//产品SKU
        Inbound_Quantity: 'Inbound Quantity',//入库数量
        Unit_Weight: 'Unit Weight',//单件重量
        Tracking_Remarks: 'Tracking Remarks',//跟踪备注
        Tracking_Number: 'Tracking Number and Related Remarks',//跟踪号及相关备注信息
        Inbound_Forecast: 'Inbound Forecast',//入库预报
        Manage_SKU: 'Manage SKU',//管理SKU
        Select_Warehouse: 'Select Warehouse',//请选择仓库
        All: 'All',//全部
        Start_Date: 'Start Date',//开始日期
        End_Date: 'End Date',//结束日期
        Enter_Batch: 'Enter Batch/ID',//请输入批次/ID
        Enter_SKU: 'Enter SKU',//请输入SKU
        Enter_Tracking_Number: 'Enter Tracking Number',//请输入跟踪号
        Enter_Internal_Box_Number: 'Enter Internal Box Number',//请输入内部箱号
        Batch_Delete: 'Batch Delete',//批量删除
        Batch_Print_PDF: 'Batch Print PDF',//批量打印PDF
        Batch_ID: 'Batch ID',//批次ID
        Warehouse: 'Warehouse',//仓库
        Batch: 'Batch',//批次
        Total_Boxes: 'Total Boxes',//总箱数
        SKU_Quantity: 'SKU Quantity',//SKU数量
        Product_Quantity: 'Product Quantity',//产品数量
        Inbound_Box_Label: 'Inbound Box Label',//入库箱贴
        Download_Warehouse_Receipt: 'Download Warehouse Receipt',//下载入仓单
        Remarks: 'Remarks',//备注
        Status: 'Status',//状态
        Forecast_Time: 'Forecast Time',//预报时间
        Inbound_Time: 'Inbound Time',//入库时间
        Edit: 'Edit',//编辑
        Delete: 'Delete',//删除
        Box_ID: 'Box ID',//箱号ID
        Box_Number: 'Box Number',//箱号
        Internal_Box_Number: 'Internal Box Number',//内部箱号
        Tracking_Number: 'Tracking Number',//跟踪号
        Quantity: 'Quantity',//数量
        SKU_Inbound_ID: 'SKU Inbound ID',//SKU入库ID
        Inbound_Batch_ID: 'Inbound Batch ID',//入库批次ID
        Inbound_Box_ID: 'Inbound Box ID',//入库箱号ID
        Barcode: 'Barcode',//条形码
        Barcode_Natural: 'Barcode (Natural Sequence)',//条形码(自然序号)
        Unit_Weight: 'Unit Weight (kg)',//单件重(kg)
        By_Batch: 'By Batch',//按批次
        By_Box_Number: 'By Box Number',//按箱号
        By_SKU: 'By SKU',//按SKU
        Today: 'Today',//今天
        Yesterday: 'Yesterday',//昨天
        This_Week: 'This Week',//本周
        This_Month: 'This Month',//本月
        Last_Month: 'Last Month',//上月
        Last_7_Days: 'Last 7 Days',//最近一周
        Last_30_Days: 'Last 30 Days',//最近一个月
        Last_90_Days: 'Last 90 Days',//最近三个月
        Please_select_the_data_to_print: 'Please select the data to print',//请选择要打印的数据
        Please_select_the_data_you_want_to_operate: 'Please select the data you want to operate',//请选择您要操作的数据
        File_read_error: 'File read error。',//文件读取错误。
        API_error_please_contact_the_administrator: 'API error, please contact the administrator',//接口错误,请联系管理员
        Please_select_the_data_to_operate: 'Please select the data to operate',//请选择要操作的数据
        Are_you_sure_you_want_to_delete: 'Are you sure you want to delete?',//您确定要删除吗
        Prompt: 'Prompt',//提示
        SKU_Box_Label: 'SKU Box Label',//SKU箱贴
        Actions: 'Actions',//操作
        Query_Records: 'Query Records',//查询记录
    },
    // 入库记录  管理sku
    jilu_skugl: {
        SKU_Management: 'SKU Management',//管理SKU
        Enter_SKU_or_product_name: 'Enter SKU or product name',//请输入sku或产品名称
        Enter_mapping_SKU: 'Enter mapping SKU',//请输入映射SKU
        Search: 'Search',//搜索
        Export_data: 'Export data',//导出数据
        Batch_print_barcodes: 'Batch print barcodes',//批量打印条形码
        Mapping_SKU: 'Mapping SKU',//映射SKU
        Import_SKU: 'Import SKU',//导入SKU
        Add_SKU: 'Add SKU',//添加SKU
        Enter_SKU_one_per_line_or_separated_by_commas: 'Enter SKUs, one per line or separated by commas',//请输入sku,每行一个或逗号隔开
        Mapping_SKU: 'Mapping SKU',//映射SKU
        Product_name: 'Product name',//产品名称
        SKU_declared_value: 'SKU declared value',//SKU申报价值
        Weight: 'Weight(kg)',//重量(kg)
        DimensionsLWH: 'Dimensions L(cm)×W(cm)×H(cm)',//长(cm)x宽(cm)x高(cm)
        Barcode: 'Barcode',//条形码
        Actions: 'Actions',//操作
        Delete: 'Delete',//删除
        Batch_import_SKU: 'Batch import SKU',//批量导入SKU
        Select_template: 'Select template',//选择模板
        SKU_batch_import: 'SKU batch import',//SKU批量导入
        Upload_file: 'Upload file',//上传文件
        Drag_file_here_or: 'Drag file here or',//将文件拖到此处，或
        Click_to_upload: 'Click to upload',//点击上传
        Excel_files_only: 'Excel files only',//只能上传excel文件
        Maximum_3000_rows: '(Maximum 3000 rows in .xlsx file!)',//（最大限制3000行.xlsx文件!）
        Confirm_add: 'Confirm add(Ctrl+S)',//确认添加(Ctrl+S)
        Clear: 'Clear',//取消清空
        Yes: 'Yes',//是
        No: 'No',//否
        If_mapped_SKU_is_already_bound: 'If mapped SKU is already bound, unbind and rebind to current system SKU?',//若映射SKU已被绑定过，是否解绑并与当前的系统SKU绑定？
        Cancel: 'Cancel',//取消
        Edit_mapping_SKU: 'Edit mapping SKU',//编辑映射SKU
        System_SKU: 'System SKU',//系统SKU
        Multiple_mapping_SKUs_should_be: 'Multiple mapping SKUs should be separated by semicolons ";" ',//多个映射SKU请用英文分号';'分割
        Edit_SKU_name: 'Edit SKU name',//编辑SKU名称
        Enter_product_name: 'Enter product name',//请输入产品名称
        English_name: 'English name',//英文名称
        Enter_English_name: 'Enter English name',//请输入英文名称
        Please_select_at_least_one_SKU: 'Please select at least one SKU',//请至少选择一个sku
        Confirm_to_delete_last_submitted_mapping_SKU: 'Confirm to delete last submitted mapping SKU?',//您确定要删除上一次提交映射的SKU吗
        Notification: 'Notification',//提示
        Confirm: 'Confirm',//确定
        This_operation_will_delete_all_inbound: 'This operation will delete all inbound and inventory data, confirm deletion?',//该操作将删除所有入库及库存数据，确认删除吗
        Batch: 'Batch',//批
        Confirm_Edit: 'Confirm Edit(Ctrl+S)',//确认编辑(Ctrl+S)
    },
    // 库存管理
    skugl_p: {
        Inbound_Forecast: 'Inbound Forecast',//入库预报
        Manage_SKU: 'Manage SKU',//管理SKU
        Update_Inventory: 'Update Inventory',//更新库存
        Keyword: 'Keyword',//关键字
        Enter_keyword: 'Enter keyword (SKU/Product Name)',//请输入关键字(SKU/产品名称)
        Mapping_SKU: 'Mapping SKU',//映射SKU
        Enter_Mapping_SKU: 'Enter Mapping SKU',//请输入映射SKU
        No_Inventory: 'No Inventory',//无库存
        Filtered_Results: 'Filtered Results',//已筛选出
        order_records: 'order records',//条订单信息
        Filter: 'Filter',//筛选
        Reset: 'Reset',//重置
        Total_Inbound: 'Total Inbound/Outbound Quantity',//出入库总数量统
        Inbound: 'Inbound',//入库
        Outbound: 'Outbound',//出库
        Remaining: 'Remaining',//剩余
        Pending_Inbound: 'Pending Inbound',//待入库
        Inventory_Transfer: 'Inventory Transfer',//库存调仓
        Alert_Settings: 'Alert Settings',//预警设置
        Export_Data: 'Export Data',//导出数据
        SKU_Declared_Value: 'SKU Declared Value',//SKU申报价值
        Contains_Battery: 'Contains Battery',//是否带电
        Warehouse_Name: 'Warehouse Name',//仓库名称
        Product_Name: 'Product Name',//产品名称
        Inbound_Quantity: 'Inbound Quantity',//入库数量
        Outbound_Quantity: 'Outbound Quantity',//出库数量
        Remaining_Quantity: 'Remaining Quantity',//剩余数量
        Volume: 'Volume',//体积
        Total_Volume: 'Total Volume',//总体积
        Unit_Weight: 'Unit Weight(kg)',//单件重(kg)
        Storage_Fee: 'Storage Fee',//仓储费
        Monthly: 'Monthly',//月
        Per_item_Handling_Fee: 'Per-item Handling Fee',//单件处理费
        Per_item_Inbound_Fee: 'Per-item Inbound Fee',//单件入库费
        Length: 'Length(cm)',//长(cm)
        Width: 'Width(cm)',//宽(cm)
        Height: 'Height(cm)',//高(cm)
        Actions: 'Actions',//操作
        Edit: 'Edit',//编辑
        Alert_Quantity: 'Alert Settings',//预警数量
        PAlert_Quantity: 'Alert Quantity',//请输入预警数量
        Enter_Alert_Quantity: 'Enter Alert Quantity ',//应用到全部
        No: 'No',//否
        Yes: 'Yes',//是
        Confirm: 'Confirm',//确认
        Cancel: 'Cancel',//取消
        Edit_Dimensions: 'Edit Dimensions',//编辑尺寸
        Cargo_Dimensions: 'Cargo Dimensions:',//货物尺寸
        Enter_Length: 'Enter Length',//请输入长
        Enter_Width: 'Enter Width',//请输入宽
        Enter_Height: 'Enter Height',//请输入高
        Close_Search: 'Close Search',//关闭搜索
        Select_Data_for_Alert_Setting: 'Select Data for Alert Setting    ',//请选择要设置预警的数据
        Open_Search: 'Open Search',//开启搜索
        This_action_will_delete_the_SKU: 'This action will delete the SKU along with all its inbound records. Confirm deletion?',//该操作删除SKU的同时，将会同时删除所有的入库记录，确认删除吗？
        tip: 'Notification',//提示
    },
    // 订单列表  编辑详情
    gnpop: {
        Order_Details: 'Order Details',//订单详情
        Close: 'Close',//关闭
        Tracking_Number: 'Tracking Number:',//运单号:
        Click_to_Copy: 'Click to Copy',//单击复制
        Customer_Reference: 'Customer Reference:',//客户单号:
        Internal_ID: 'Internal ID:',//内部ID:
        Refresh: 'Refresh',//刷新
        Print_System_Label: 'Print System Label',//打印系统标签
        Copy_Order: 'Copy Order',//复制订单
        Service_Type: 'Service Type',//服务类型
        Not_Applicable: 'Not Applicable',//暂无
        Destination_Country: 'Destination Country',//发往国家
        Actual_Weight: 'Actual Weight',//实际重量
        Volumetric_Weight: 'Volumetric Weight',//体积重量
        Chargeable_Weight: 'Chargeable Weight',//计费重量
        Cubic_Measurement: 'Cubic Measurement',//方数
        Dimensional_Weight: 'Dimensional Weight',//材积数
        Number_of_Boxes: 'Number of Boxes',//箱数
        Zone: 'Zone',//分区
        Fee: 'Fee',//费
        Usage: 'Usage',//用
        Postage_Fee: 'Postage Fee',//邮费
        Registration_Fee: 'Registration Fee',//挂号费
        Handling_Fee: 'Handling Fee',//处理费
        Fuel_Surcharge: 'Fuel Surcharge',//燃油费
        Other_Fees: 'Other Fees',//其他杂费
        Pending_Verification: 'Pending Verification',//待核销
        Total: 'Total',//总计
        Refund: 'Refund',//退款
        on: 'on',//于
        Request: 'Request',//申请
        Shipping_Address: 'Shipping Address',//收件地址
        Edit: 'Edit',//编辑
        Customer_Notes: 'Customer Notes',//客户备注
        Enter_notes: 'Enter notes',//请输入备注
        Routing_Information: 'Routing Information',//路由信息
        Related_Information: 'Related Information',//相关信息
        Yes: 'Yes',//是
        No: 'No',//否
        Please_Enter: 'Please Enter',//请输入
        Required: '[Required]',//[必填]
        Carton_Information: 'Carton Information',//货箱信息
        System_Carton_ID: 'System Carton ID',//系统箱号
        Dimensions: 'Dimensions',//尺寸
        Actual_Weight: 'Actual Weight',//实重
        Chargeable_Weight: 'Chargeable Weight',//本箱取值重量
        Volumetric_Weight: 'Volumetric Weight',//体积重
        Copy: 'Copy',//复制
        By_Shipment: '[By Shipment]',//[按票]
        By_Carton: '[By Carton]',//[按箱]
        Declaration_Information: 'Declaration Information',//申报信息
        Total_Products: 'Total Products:',//产品总数：
        Declared_Total_Value: 'Declared Total Value:',//申报总价值：
        Total_Purchase_Price: 'Total Purchase Price:',//采购总价：
        Product_Items: 'Product Items:',//品名数量：
        Cost_Information: 'Cost Information',//费用信息
        Fee_Type: 'Fee Type',//费用类型
        Billing_Unit: 'Billing Unit',//收费单位
        Fee_Per_Unit: 'Fee Per Unit',//每单位费
        Currency: 'Currency',//费用币种
        Exchange_Rate: 'Exchange Rate',//收费汇率
        Fee_Description: 'Fee Description',//费用描述
        Internal_Notes: 'Internal Notes',//内部备注
        Transaction_Time: 'Transaction Time',//业务时间
        Charges: 'Charges',//费用
        Order_Fees_Under_Audit: 'Order Fees Under Audit...',//订单费用审计中.....
        Attachments: 'Attachments',//附件
        Upload_Attachment: 'Upload Attachment',//上传附件
        Upload_FBA_Label: 'Upload FBA Label',//上传FBA标签
        Upload_Time: 'Upload Time',//上传时间
        Uploaded_By: 'Uploaded By',//上传人
        Delete: 'Delete',//删除
        Work_Order: 'Work Order',//工单
        Add: 'Add',//添加
        Work_Order_Content: 'Work Order Content',//工单内容
        Status: 'Status',//状态
        Creation_Time: 'Creation Time',//创建时间
        Last_Reply: 'Last Reply',//最后回复
        Battery_Included: 'Battery Included',//带电
        Magnetic: 'Magnetic',//带磁
        Hazardous_Materials: 'Hazardous Materials',//危险品
        Liquid: 'Liquid',//液体
        Powder: 'Powder',//粉末
        Paste: 'Paste',//膏体
        General_Cargo: 'General Cargo',//普货
        Sensitive_Goods: 'Sensitive Goods',//敏感货
        Wooden_Products: 'Wooden Products',//木制品
        Textiles: 'Textiles',//纺织品
        Sum_chargeable_weight: 'Sum chargeable weight (round up per carton)',//取每个箱子 实重抛重大数后合计
        Total_chargeable_weight: 'Total chargeable weight (sum then round up)',//取所有箱子 实重抛重相加后大数
        Sum_actual_weight: 'Sum actual weight',//取所有箱子 实重相加
        Sum_volumetric_weight: 'Sum volumetric weight',//取所有箱子 体积重相加
        Charge_by_actual_weight: 'Charge by actual weight',//按实重计费
        Charge_by_volumetric_weight: 'Charge by volumetric weight',//按体积重计费
        Charge_by_greater_of_actual: 'Charge by greater of actual/volumetric',//按实重体积重大数计费
        Basic_Information: 'Basic Information',//基础信息
        Address_Routing: 'Address Routing',//地址路由
        Carton_Information: 'Carton Information',//货箱信息
        Declaration_Info: 'Declaration Info',//申报信息
        Cost_Information: 'Cost Information',//费用信息
        Attachments: 'Attachments',//附件工单
        Copied_successfully: 'Copied successfully!',//复制成功!
        Loading: 'Loading',//玩命加载中
        File_read_error: 'File read error。',//文件读取错误。
        API_error: 'API error, please contact admin',//接口错误,请联系管理员
        This_will_permanently_delete_the_file: 'This will permanently delete the file. Continue?',//此操作将永久删除该文件, 是否继续?
        Notification: 'Notification',//提示
        Confirm: 'Confirm',//确定
        Cancel: 'Cancel',//取消
        Deletion_cancelled: 'Deletion cancelled',//已取消删除
        File_size_cannot_exceed: 'File size cannot exceed 5MB!',//上传文件大小不能超过 5MB!
        Carton_No: 'Carton No',//箱号
        Weight: 'Weight',//重量
        Length: 'Length',//长
        Width: 'Width',//宽
        Height: 'Height',//高
        Billing_Method: 'Billing Method:',//计费方式：
        Chargeable_Weight: 'Chargeable Weight:',//计费重量：
        This_Shipments_Chargeabl_Weight: 'This Shipments Chargeable Weight',//本票取值重量
        File_Name: 'File Name',//文件名称
        Actions: 'Actions',//操作
        Total: 'Total:',//总计：
    },
    // 订单列表  批量上传跟踪号
    openGenzong: {
        Batch_Upload_Tracking_Numbers: 'Batch Upload Tracking Numbers',//批量上传跟踪号
        Download_template: 'Download template',//下载模板
        Download: 'Download',//下载
        Import_data: 'Import data',//导入数据
        Drag_file_here_or: 'Drag file here or',//将文件拖到此处，或
        Click_to_upload: 'Click to upload',//点击上传
        Upload_Excel: 'Upload Excel',//上传EXCEL
        Cancel: 'Cancel',//取消
        Please_upload_the_file: 'Please upload the file',//请上传文件
    },
    //库存记录  添加调仓
    InventoryAdjustment: {
        Add_Transfer: 'Add Transfer',//添加调仓
        Select_Transfer: 'Select Transfer',//选择调仓
        Select_SKUs_to_Transfer: 'Select SKUs to Transfer',//选择需要转移的SKU
        Destination_Warehouse: 'Destination Warehouse',//目的仓库
        Please_Select_Destination_Warehouse: 'Please Select Destination Warehouse',//请选择目的仓库
        Warehouse_Name: 'Warehouse Name',//仓库名称
        Transfer_Quantity: 'Transfer Quantity',//转移数量
        Remaining_Quantity: 'Remaining Quantity',//剩余数量
        Inbound_Quantity: 'Inbound Quantity',//入库数量
        Outbound_Quantity: 'Outbound Quantity',//出库数量
        Volume: 'Volume',//体积
        Transfer_Remarks: 'Transfer Remarks',//调仓备注
        Please_Enter_Content: 'Please Enter Content',//请输入内容
        SKU_List: 'SKU List',//SKU列表
        Current_Transfer_List: 'Current Transfer List',//当前调仓表
        Action: 'Action',//操作
        Save: ' Save (Ctrl+S)',//保存(Ctrl+S)
        Cancel: 'Cancel',//取消
        Add_to_Transfer_List: 'Add to Transfer List',//加入调仓表
        Complete_Transfer: 'Complete Transfer',//完成调仓
        Operation_Successful: 'Operation Successful',//操作成功
        back: 'Back',//返回
    },
    //海外订单列表 编辑详情弹窗
    haiwaipop: {
        Order_Number: 'Order No:',//订单号：
        Click_to_Copy: 'Click to Copy',//单击复制
        Internal_ID: 'Internal ID:',//内部ID:
        Refresh: 'Refresh',//刷新
        Download_Label: 'Download Label',//下载Label
        Copy_Order: 'Copy Order',//复制订单
        // Base: 'Base',//基
        // Foundation: 'Foundation',//础
        // Information: 'Information',//信
        // :'*息',//息
        Basic_Information: 'Basic Information',//基础信息
        Service_Type: 'Service Type',//服务类型
        None: 'None',//暂无
        Destination_Country: 'Destination Country',//发往国家
        Actual_Weight: 'Actual Weight',//实际重量
        Volumetric_Weight: 'Volumetric Weight',//体积重量
        Billing_Weight: 'Billing Weight',//计费重量
        Dimensional_Volume: 'Dimensional Volume',//材积数
        Number_of_Boxes: 'Number of Boxes',//箱数
        Zone: 'Zone',//分区
        Fee: 'Fee',//费
        Usage: 'Usage',//用
        Shipping_Fee: 'Shipping Fee',//邮费
        Registration_Fee: 'Registration Fee',//挂号费
        Handling_Fee: 'Handling Fee',//处理费
        Fuel_Surcharge: 'Fuel Surcharge',//燃油费
        Other_Miscellaneous_Fees: 'Other Miscellaneous Fees',//其他杂费
        Orders_with_potentially: 'Orders with potentially inaccurate fees will be frozen, and the corresponding amount will be held. The freeze will be lifted and actual fees deducted after verification 。',//冻结中属于费用可能存在不准确的订单，该类订单会被冻结相应的金额，核销后会取消冻结并真实扣费。
        Frozen: 'Frozen',//冻结中
        Total: 'Total',//总计
        Refund: 'Refund',//退款
        On: 'On',//于
        Apply: 'Apply',//申请
        repair: 'repair',//补
        receive: 'receive',//收
        Order_ID: 'Order ID',//订单id
        Sub_Order_Field: 'Sub-Order Field',//子订单字段
        Channel_Description: 'Channel Description',//渠道简介
        Approval_Fee: 'Approval Fee',//审批费用
        Fee: 'Fee',//费用
        Creation_Time: 'Creation Time',//创建时间
        Unapproved: 'Unapproved',//未审批
        Approved: 'Approved',//已审批
        Shipping_Address: 'Shipping Address',//收件地址
        Edit: 'Edit',//编辑
        Sender_Address: 'Sender Address',//发件地址
        Select: 'Select',//选择
        Routing_Information: 'Routing Information',//路由信息
        Customer_Remarks: 'Customer Remarks',//客户备注
        Price_Estimation: 'Price Estimation',//试算价格
        Click_Channel_to_Create_Order: 'Click Channel to Create Order',//点击渠道进行出单
        This_channel_is_locked: 'This channel is locked to the following address',//该渠道锁定以下地址
        Current_Status: 'Current Status:',//当前状态:
        Loaded_into_Container: 'Loaded into Container',//已装柜
        Container_Information: 'Container Information',//货箱信息
        System_Box_No: 'System Box No',//系统箱号
        Actual_Weight: 'Actual Weight',//实重
        Shipping_Information: 'Shipping Information',//发货信息
        Product_Name: 'Product Name',//产品名称
        SKU_Image: 'SKU Image',//SKU图片
        Declared_Unit_Price: 'Declared Unit Price',//申报单价
        Quantity: 'Quantity',//数量
        Declaration_Information: 'Declaration Information',//申报信息
        Total_Products: 'Total Products:',//产品总数：
        Total_Declared_Value: 'Total Declared Value:',//申报总价值：
        Total_Purchase_Price: 'Total Purchase Price:',//采购总价：
        Product_Quantity: 'Product Quantity:',//品名数量：
        Box_No: 'Box No',//箱号
        Product_SKU: 'Product SKU',//商品SKU
        Chinese_Product_Name: 'Chinese Product Name',//中文品名
        English_Product_Name: 'English Product Name',//英文品名
        Material: 'Material',//材质
        Purpose: 'Purpose',//用途
        Product_Weight: 'Product Weight',//产品重量
        HS_Code: 'HS Code',//海关编码
        Battery_Description: 'Battery Description',//电池描述
        Status: 'Status',//状态
        Time: 'Time',//时间
        Basic_Information: 'Basic Information',//基础信息
        Address_Routing: 'Address Routing',//地址路由
        Operation_Log: 'Operation Log',//操作日志
        Loading: 'Loading',//玩命加载中
        Copied_Successfully: 'Copied Successfully',//复制成功
        Please_Select_Sender_Address: 'Please Select Sender Address',//请选择发件地址
        Total_Weight: 'Total Weight',//总重量
        Add: 'Add',//添加
        Dimensions: 'Dimensions',//尺寸
        Close: 'Close',//关闭
    },
    // 海外发货  仓租提醒
    daishouCz: {
        Storage_overdue_rate_multiplier: 'Overdue Rental Rate Multiplier',//仓租超期倍率
        SKU_inbound_ID: 'SKU Inbound ID',//SKU入库ID
        End_date: 'End Date',//结束日期
        Start_date: 'Start Date',//开始日期
        Reset: 'Reset',//重置
        Export: 'Export',//导出
        Warehouse_name: 'Warehouse Name',//仓库名称
        Actual_inbound_quantity: 'Actual Received Quantity',//实入数量
        Remaining_quantity: 'Remaining Quantity',//剩余数量
        Storage_fee_unit_price: 'Storage Fee Unit Price',//仓储费单价
        Storage_rental_due: 'Rental Due (Days)',//仓租到期(天)
        Storage_overdue: 'Rental Overdue',//仓租超期
        day: 'Day',//天
        Received: 'Received (times)',//已收(次)
        Inbound_time: 'Inbound Time',//入库时间
        Current_Rental_Cycle_Start_Time: 'Current Rental Cycle Start Time (Inbound)',//入库本次收租周期时间
        Warehouse_Rental: 'Warehouse Rental',//仓租
        Quantity: 'Quantity',//数量
        Volume: 'Volume',//体积
        Rental_Collection_Time: 'Rental Collection Time',//收租时间
        Amount: 'Amount',//金额
        Rental_Reminder: 'Rental Reminder (Within 90 Days)',//仓租提醒（90天内）
        Received_Records: 'Received Records',//已收记录
        Please_Select_Time_Range: 'Please Select Time Range',//请选择时间范围
        All: 'All',//全部
        Inbound_Days: 'Inbound Days',//入库天数
    },
    // 海外发货  仓租提醒 仓租超期倍率
    chaoqibeilv: {
        Overdue_Storage_Fee_Multiplier: 'Overdue Storage Fee Multiplier',//仓租超期倍率
        Xth_Month_After_Free_Storage_Period: 'Xth Month After Free Storage Period',//免租期后第(x)月
        Storage_Fee_Unit_Price_Multiplier: 'Storage Fee Unit Price Multiplier',//仓储费单价倍率
    },
    // sku管理 添加映射sku
    z_addyingshe: {
        SKU_Mapping_Added_Successfully: 'SKU Mapping Added Successfully',//添加映射SKU成功
        Add_SKU_Mapping: 'Add SKU Mapping',//添加映射SKU
        Edit_SKU_Mapping: 'Edit SKU Mapping',//编辑映射SKU
        SKU_Mapping: 'SKU Mapping',//映射SKU
        Enter_Mapped_SKU: 'Enter Mapped SKU',//请输入映射SKU
        System_SKU: 'System SKU',//系统SKU
        Enter_System_SKU: 'Enter System SKU',//请输入系统SKU
        Enter_Quantity: 'Enter Quantity',//请输入数量
        Cancel: 'Cancel',//取消
        Remark: 'Remark'
    },
    // 订单列表 拆分订单
    Caifen_pofeitou: {
        Split_Order: 'Split Order',//拆分订单
        Quantity: 'Quantity',//数量
        Declared_Unit_Price: 'Declared Unit Price',//申报单价
        Please_Select_SKU: 'Please Select SKU',//请选择sku
        Please_Enter_Quantity: 'Please Enter Quantity',//请输入数量
        Confirm_Split: 'Confirm Split(Ctrl+S)',//确认拆分(Ctrl+S)
        Order_Split_Successfully: 'Order Split Successfully',//拆分成功
        Cancel: 'Cancel',//取消
        Quantity_cannot_exceed_original_SKU_quantity: 'Quantity cannot exceed original SKU quantity',//数量不能大于原SKU数量
    },
    // 拆分订单数量
    caifen_num: {
        Split_Order_Quantity: 'Split Order Quantity',//拆分订单数量
        Enter_Split_Quantity: 'Enter Split Quantity',//请输入拆分数量
        Cancel: 'Cancel',//取 消
        Confirm: 'Confirm',//确 定
    },
    // 编辑发货
    hottable: {
        Shipment_Editing: 'Shipment Editing',//编辑发货
        Cancel: 'Cancel',//取 消
        Confirm: 'Confirm(Ctrl+S)',//确 定(Ctrl+S)
        Quantity: 'Quantity',//数量
        Declared_Unit_Price: 'Declared_Unit_Price',//申报单价
    },
    // 订单列表 编辑收件信息
    xqedit: {
        Edit_Recipient_Information: 'Edit Recipient Information',//编辑收件信息
        Order_ID: 'Order ID',//订单ID
        Please_enter_Order_ID: 'Please enter Order ID',//请输入订单ID
        Company_Name: 'Company Name',//公司名称
        Please_enter_Company_Name: 'Please enter Company Name',//请输入公司名称
        Address_Lin_1: 'Address Line 1',//地址一
        Please_enter_Address_Line_1: 'Please enter Address Line 1',//请输入地址一
        Country: 'Country',//国家
        Please_select_Country: 'Please select Country',//请选择国家
        City: 'City',//城市
        Please_enter_City: 'Please enter City',//请输入城市
        House: 'House',//门牌号
        Please_enter_House: 'Please enter House',//请输入门牌号
        Recipient_Name: 'Recipient Name',//收件姓名
        Please_enter_Recipient_Name: 'Please enter Recipient Name ',//请输入收件姓名
        Phone_Number: 'Phone Number',//电话号码
        Please_enter_Phone_Number: 'Please enter Phone Number',//请输入电话号码
        Address_Line_2: 'Address Line 2',//地址二
        Please_enter_Address_Line_2: 'Please enter Address Line 2',//请输入地址二
        State_Province: 'State/Province',//州/省
        Please_enter_State_Province: 'Please enter State/Province',//请输入州/省
        Postal_Code: 'Postal Code',//邮编
        Please_enter_Postal_Code: 'Please enter Postal Code',//请输入邮编
        Update_Address: 'Update Address (Ctrl+S)',//更新地址(Ctrl+S)
        Frequently_Used: 'Frequently Used',//常用
        Sender: 'Sender',//发件 
        Please_enter_Address_Alias: 'Please enter Address Alias',//请输入地址别名
        Please_enter_country: 'Please enter country',//请输入国家
        Please_enter_Sender_Name: 'Please enter Sender Name',//请输入发件姓名
    },
    // 入库记录 双击详情
    rukuxinqging: {
        Batch: 'Batch:',//批次：
        Carton_No: 'Carton No:',//箱号：
        Warehouse: 'Warehouse',//仓库
        Carton_Number: 'Carton Number',//箱号
        Product_Name: 'Product Name',//产品名称
        Status: 'Status',//状态
        Estimated_Quantity: 'Estimated Quantity',//预报数量
        Actual_Received_Quantity: 'Actual Received Quantity',//实到数量
        Estimated_Weight: 'Estimated Weight (kg)',//预报重量(kg)
        Actual_Weight: 'Actual Weight (kg)',//实际重量(kg)
        Dimensions: 'LxWxH(cm)',//长宽高(cm)
        Remarks: 'Remarks',//备注
        Handling_Fee: 'Handling Fee/Unit',//处理费/件
        Storage_Fee: 'Storage Fee/Unit',//入库费/件
        Export: 'Export',//导出
        Export_succeeded: 'Export succeeded',//导出成功
    },
    //库存管理 双击详情
    inventorydetail: {
        Inventory_Details: 'Inventory Details',//库存详情
        Warehouse_Name: 'Warehouse Name',//仓库名称
        Product_SKU: 'Product SKU',//产品SKU
        Shelf_Location: 'Shelf Location',//货架位置
        Storage_Fee_per_Unit: 'Storage Fee per Unit',//仓储费单价
        Remaining_Quantity: 'Remaining Quantity',//剩余数量
        Shipped_Quantity: 'Shipped Quantity',//已发货数量
        Total_Inbound_Quantity: 'Total Inbound Quantity',//总入库数量
        Single_Inbound_Fee: 'Single Inbound Fee',//单件入库费
        Dimensions: 'Dimensions (L x W x H in cm)',//长宽高(cm)
        Weight: 'Weight (kg)',//重量(kg)
        Single_Handling_Fee: 'Single Handling Fee',//单件处理费
        Export_Outbound_Records: 'Export Outbound Records',//导出出库记录
        Inbound_Records: 'Inbound Records',//入库记录
        Outbound_Records: 'Outbound Records',//出库记录
    },
    // 平台管理  平台账号
    P_ptzh: {
        Bind_Platform_Account: 'Bind Platform Account',//绑定平台账号
        Platform: 'Platform',//平台
        All: 'All',//全部
        Status: 'Status',//状态
        Store_Name: 'Store Name',//店铺名称
        Please_enter_keywords: 'Please enter keywords (Store Name)',//请输入关键字(店铺名称)
        Platform_Name: 'Platform Name',//平台名称
        Account_Status: 'Account Status',//账号状态
        Enable: 'Enable',//启用
        Disable: 'Disable',//禁用
        Creation_Time: 'Creation Time',//创建时间
        Store_SKU: 'Store SKU',//店铺SKU
        Add_SKU: 'Add SKU',//添加SKU
        Actions: 'Actions',//操作
        Fetch_Orders: 'Fetch Orders',//拉取订单
        Manage: 'Manage',//管理
        Edit: 'Edit',//编辑
        Delete: 'Delete',//删除
        Fetch_Time: 'Fetch Time',//拉取时间
        Select_Date: 'Select Date',//选择日期
        Fetch_Type: 'Fetch Type',//拉取类型
        Fetch_Orders_Only: 'Fetch Orders Only',//仅拉取订单
        Shipping_LabelT: 'Shipping Label (Transfer Orders)',//面单(转入订单)
        Shipping_LabelA: 'Shipping Label (Auto-fulfill Orders)',//面单(自动出单)
        Channel_Selection: 'Channel Selection',//渠道选择
        Please_select_channel: 'Please select channel',//请选择渠道选择
        Fetch: 'Fetch',//拉 取
        Cancel: 'Cancel',//取 消
        Confirm_to_delete_this_account: 'Confirm to delete this account?',//确认删除该账号？
    },
    //   平台账号  绑定平台账号
    zhadd_drawer: {
        Edit_Bound_Platform_Account: 'Edit Bound Platform Account',//编辑绑定平台账号
        Bind_Platform_Account: 'Bind Platform Account',//绑定平台账号
        Auto_Transfer: 'Auto Transfer',//是否自动转入
        No: 'No',//否
        Yes: 'Yes',//是
        Order_Module: 'Order Module',//订单模块
        Select_Warehouse: 'Select Warehouse',//选择仓库
        Please_Select_Warehouse: 'Please Select Warehouse',//请选择仓库
        Select_Platform: 'Select Platform',//选择平台
        Account_Authorization: 'Account Authorization',//账号授权
        Click_Here_to_Authorize_U: 'Click Here to Authorize (USA)',//第一步：点击此处开始授权(美国)
        Click_Here_to_Authorize_O: 'Click Here to Authorize (Other Regions)',//第一步：点击此处开始授权(其它地区)
        Click_Here_to_Authorize_y: 'China Cross border Merchant Authorization',//第一步：点击此处开始授权(其它地区)

        Existing_Account: 'Existing Account',//已有账号
        Store_Name: 'Store Name',//店铺名称
        Please_Enter_Store_Name: 'Please Enter Store Name',//请输入店铺名称
        Cannot_Be_Empty: 'Cannot Be Empty',//不能为空
        Please_Fill_In: 'Please Fill In',//请填写
        Confirm_Edit_Binding: 'Confirm Edit Binding (Ctrl+S)',//确认编辑绑定(Ctrl+S)
        Confirm_Binding: 'Confirm Binding (Ctrl+S)',//确认绑定(Ctrl+S)
        Cancel: 'Cancel',//取消
        Please_Select_Platform_to_Bind: 'Please Select Platform to Bind',//请选择绑定的平台
        Please_Enter_Store_Name: 'Please Enter Store Name',//请输入店铺名称
        Select: 'Select',//选
    },
    // 临时订单列表
    lsddList: {
        Please_enter_platform: 'Please enter platform/order number',//请输入平台/订单号
        Transferred_orders: 'Transferred orders',//已转入订单
        Generate_order: 'Generate order',//生成订单
        Menu_selection: 'Menu selection',//菜单选择
        Select_warehouse: 'Select warehouse',//选择仓库
        Please_select_warehouse: 'Please select warehouse',//请选择仓库
        Select_channel: 'Select channel',//选择渠道
        Please_select_channel: 'Please select channel',//请选择渠道
        Select: 'Select',//选
        Confirm_generation: 'Confirm generation (Ctrl+S)',//确认生成(Ctrl+S)
        Cancel: 'Cancel',//取消
        Confirm: 'Confirm',//确 定
        Cancel_order: 'Cancel order',//取消订单
        Please_select_failure_reason: 'Please select failure reason',//请选择失败原因
        Cancellation_successful: 'Cancellation successful',//取消成功
        Failed_to_set_label: 'Failed to set label, please try again later',//设置标签失败，请稍后再试
        Setup_successful: 'Setup successful',//设置成功
        Please_select_orders_to_operate: 'Please select orders to operate',//请选择要操作的订单
        Failed_to_get_order_list: 'Failed to get order list',//获取订单列表失败
        All: 'All',//全部
        Temporary_orders: 'Temporary orders',//临时订单
        Transferred_orders: 'Transferred orders',//已转入订单
    },
    // 临时订单列表 状态管理
    OrderTagManage: {
        Select: 'Select',//选择
        Label_Name: 'Label Name',//标签名称
        Please_enter_label_name: 'Please enter label nam',//请输入标签名称
        Actions: 'Actions',//操作
        Edit: 'Edit',//修改
        Delete: 'Delete',//删除
        Save: 'Save',//保存
        Add: 'Add',//添加
        Undo: 'Undo',//撤销
        SaveC: 'Save(Ctrl+S)',//保存(Ctrl+S)
        Cancel: 'Cancel',//取消
        Status_Label_Management: 'Status Label Management',//状态标签管理
        Are_you_sure_you_want_to_delete_this_label: 'Are you sure you want to delete this label?',//是否确定删除此标签？
        Prompt: 'Prompt',//提示
        Confirm: 'Confirm',//确定
        Deletion_failed: 'Deletion failed, please try again later',//删除失败，请稍后再试
        Label_name_cannot_be_empty: 'Label name cannot be empty',//标签名称不能为空
        Add_failed: 'Add failed, please try again later',//添加失败，请稍后再试
        Edit_failed: 'Edit failed, please try again later',//修改失败，请稍后再试
        Failed_to_fetch_label_list: 'Failed to fetch label list',//获取标签列表失败
    },
    // 财务流水
    cwliusui: {
        Available: 'Available',//可用
        Balance_Statistics: 'Balance Statistics',//余额统计
        Balance: 'Balance',//余额
        Credit_Line: 'Credit Line',//授信
        Temporary_Limit: 'Temporary Limit',//临额
        Expired: 'Expired:',//过期:
        Deposit: 'Deposit',//押金
        Frozen: 'Frozen',//冻结
        Available_Credit: 'Available Credit',//可用额度
        Financial_Transactions: 'Financial Transactions',//财务流水
        Online_Recharge: 'Online Recharge',//在线充值
        All: 'All',//全部
        Frozen_Amount: 'Frozen Amount:',//冻结金额：
        Start_Date: 'Start Date',//开始日期
        End_Date: 'End Date',//结束日期
        Keywords: 'Keywords',//关键字
        Query_Records: 'Query Records',//查询记录
        Export: 'Export',//导出
        The_monthly_amount_is_linked_to_account_balance: '*The monthly amount is linked to account balance. The system automatically recalculates and records monthly spending amounts daily, then updates the account balance',//该月度金额关联帐户余额，系统每天会自动从头再统计每个月的消费金额并写入数据库，然后得出帐户余额。
        Special_Note: '*Special Note: If the system uses order creation functionality, recharge calculations use the advance creation date as the calculation node',//特别声明：如系统有使用提单功能，该充值计算是以提前创建日期为计算节点。
        For_any_inquiries: 'For any inquiries, please contact technical support',//如有疑问，请联系技术咨询。
        Click_to_manually_update: 'Click to manually update',//点击手动更新
        Finance_ID: 'Finance ID',//财务ID
        Category: 'Category',//类别
        Account: 'Account',//账户
        Estimated_Amount: 'Estimated Amount',//预报金额
        Actual_Received_Amount: 'Actual Received Amount',//实入金额
        Status: 'Status',//状态
        Remarks: 'Remarks',//备注
        Description: 'Description',//说明
        Attachment: 'Attachment',//附件
        No_image_available: 'No image available',//暂无图片
        Submission_Time: 'Submission Time',//提交时间
        Posting_Time: 'Posting Time',//入账时间
        Current_Consumption_Amount: 'Current Consumption Amount',//当前消费金额
        Current_Refund_Amount: 'Current Refund Amount',//当前退款金额
        Order_Count: 'Order Count',//订单数
        Date: 'Date',//日期
        Last_Statistics_Time: 'Last Statistics Time',//最后统计时间
        Order_Number: 'Order Number',//订单号
        Tracking_Number: 'Tracking Number',//跟踪号
        Partition: 'Partition',//分区
        Fee: 'Fee',//费用
        Creation_Time: 'Creation Time',//创建时间
        Deduction_ID: 'Deduction ID',//扣费ID
        Deduction_Amount: 'Deduction Amount',//扣费金额
        Application_Records: 'Application Records',//申请记录
        Application_Amount: 'Application Amount',//申请金额
        Available: 'Available',//可用
        Expired: 'Expired',//过期
        Application_Time: 'Application Time',//申请时间
        Expiration_Time: 'Expiration Time',//过期时间
        Posted: 'Posted',//入账
        Deducted: 'Deducted',//扣费
        Consumed: 'Consumed',//消费
        Refunded: 'Refunded',//退款
        Freezing: 'Freezing',//冻结中
        consumption_amounts_from: 'The system will recalculate monthly consumption amounts from scratch and write to database. Continue?',//即将从头再统计每个月的消费金额并写入数据库, 是否继续?
        Selected_dates_update_note: 'Select the dates to update. Only consumption records for the selected dates will be recalculated.',
        Select_date_records_first: 'Please select the date records to update',
        Update_selected_dates_confirm: 'Recalculate consumption records for the selected dates?',
        Notification: 'Notification',//提示
        Confirm: 'Confirm',//确定
        Cancel: 'Cancel',//取消
        Statistics_Failed: 'Statistics Failed',//统计失败
        Statistics_Succeeded: 'Updated successfully',
        TotalAmount: 'Total Amount',//总金额
        Export_Order_Details: 'Export Order Details',
        Export_order_details_select_tip: 'Please select the consumption date records to export',
        Export_order_details_loading: 'Exporting, please wait...',
        Export_refund_details_select_tip: 'Please select the refund date records to export',
    },
    // 财务流水  在线充值
    caiwupup: {
        Title: 'Title',//我是标题
        Recharge_Account: 'Recharge Account:',//充值账户:
        Estimated_Amount: 'Estimated Amount:',//预报金额:
        Please_Enter_Amount: 'Please Enter Amount',//请输入金额
        Recharge_Screenshot: 'Recharge Screenshot:',//充值截图:
        Upload_Screenshot: 'Upload Screenshot',//上传截图
        File: 'File(s)',//个文件
        Remarks: 'Remarks:',//备注信息:
        Please_Enter_Content: 'Please Enter Content',//请输入内容
        Recharge_Now: 'Recharge Now:',//立即充值:
        Confirm_Submission: 'Confirm Submission',//确定提交
        Clear_Content: 'Clear Content',//清空内容
        Please_contact_freight_forwarder: 'Please contact freight forwarder to add payment method in backend first',//请联系货代先在后台添加 收款方式
        Please_Select_Currency: 'Please Select Currency',//请选择充值币种
        Please_Select_Payment_Method: 'Please Select Payment Method',//请选择支付方式
        Please_Fill_in_Amount: 'Please Fill in Amount',//请填写金额
    },
    // 财务流水 导出出库记录
    addwj: {
        Export_Selected_Fields: 'Export Selected Fields',//导出选择字段
        Cancel: 'Cancel',//取 消
        Confirm: 'Confirm',//确 定
        Please_select_at_least_four_fields: 'Please select at least four fields',//请选择四个以上的字段
        Export_succeeded: 'Export succeeded',//导出成功
        Export_failed: 'Export failed',//导出失败
    },
    // 大货账单
    dhzdlist: {
        Print_Bill: 'Print Bill',//打印账单
        Bill_ID: 'Bill ID',//账单ID
        Customer_Balance: 'Customer Balance',//客户余额
        Category: 'Category',//类别
        Billing_Cycle: 'Billing Cycle',//周期
        Account_Amount: 'Account Amount',//账户金额
        Due_Date: 'Due Date',//到期时间
        Due_Limit: 'Due Limit',//到期限制
        Status: 'Status',//状态
        Please_check_the_bills_to_print: 'Please check the bills to print',//请勾选要打印的账单
    },
    // 大货账单 打印账单
    zdpdf: {
        Bill_Number: 'Bill Number:',//账单编号
        Batch_Print: 'Batch Print',//批量打印
        Basic_Bil: 'Basic Bill',//基础账单
        Detailed_Bill: 'Detailed Bill (including order list)',//完整账单(包含订单列表)
        OK: 'OK',//确 定
        Cancel: 'Cancel',//取 消
        File_read_error: 'File read error。',//文件读取错误。
        API_error: 'API error, please contact administrator',//接口错误,请联系管理员
    },
    // 小包账单
    xbaozdlist: {
        Print_Bill: 'Print Bill',//打印账单
        Bill_ID: 'Bill ID',//账单ID
        Customer_Balance: 'Customer Balance',//客户余额
        Category: 'Category',//类别
        Billing_Cycle: 'Billing Cycle',//周期
        Account_Amount: 'Account Amount',//账户金额
        Due_Date: 'Due Date',//到期时间
        Due_Limit: 'Due Limit',//到期限制
        Status: 'Status',//状态
        Please_check_the_bills_to_print: 'Please check the bills to print',//请勾选要打印的账单
    },
    // 平台账号  添加sku
    openSkuList: {
        Configure_SKU_Grouping: 'Configure SKU Grouping',//配置SKU分组
        Batch_Import: 'Batch Import',//批量导入
        Name: 'Name',//名称
        Actions: 'Actions',//操作
        Delete: 'Delete',//删除
        ConfirmC: 'Confirm (Ctrl+S)',//确认(Ctrl+S)
        Cancel: 'Cancel',//取消
        Import_SKU_Grouping: 'Import SKU Grouping',//导入SKU分组
        Download_Template: 'Download Template',//下载模板
        Download: 'Download',//下载
        Group_Name: 'Group Name',//分组名称
        Please_enter_remote_area_name: 'Please enter remote area name',//请输入偏远地区名称
        Import_Data: 'Import Data',//导入数据
        Drag_file_here_or: 'Drag file here or',//将文件拖到此处，或
        Click_to_upload: 'Click to upload',//点击上传
        Upload_EXCEL: 'Upload EXCEL',//上传EXCEL
        Configure_SKU_Grouping_Details: 'Configure SKU Grouping Details',//配置SKU分组详情列表
        Please_enter_SKU_name: 'Please enter SKU name',//请输入sku名称
        Length: 'Length',//长
        Width: 'Width',//宽
        Height: 'Height',//高
        Weight: 'Weight',//重量
        This_will_permanently_delete: 'This will permanently delete the SKU group. Continue?',//此操作将永久删除该sku分组,是否继续?
        Notification: 'Notification',//提示
        Confirm: 'Confirm',//确定
        Cancel: 'Cancel',//取消
    },
    //财务 消费 双击详情
    xiaofei: {
        Related_orders: 'Related orders',//相关订单
        Export: 'Export',//导出
        Order_ID: 'Order ID',//订单ID
        Channel_name: 'Channel name',//渠道名
        Order_Number: 'Order Number',//订单号
        Tracking_Number: 'Tracking Number',//跟踪号
        Batch_search_placeholder: 'Exact batch search, one number per line',//支持批量精确搜索，每行输入一个号码
        Search: 'Search',//搜索
        Reset: 'Reset',//重置
        Consumption_amount: 'Consumption amount',//消费金额
        Consumption_time: 'Consumption time',//消费时间
    },
    //财务 消费 退款
    orders: {
        Related_orders: 'Related orders',//相关订单
        Export: 'Export',//导出
        Order_ID: 'Order ID',//订单ID
        Channel_name: 'Channel name',//渠道名
        Order_Number: 'Order Number',//订单号
        trace_Number: 'trace  Number',//跟踪号
        Refund_amount: 'Refund amount',//退款金额
        Refund_time: 'Refund time',//退款时间
        Tracking_number: 'Tracking number',//运单号
    },
    // 财务 消费 海外仓  双击详情
    haiwaiRkdetile: {
        Information_on_warehousing: 'Information on warehousing-in fees',//入库费信息
        Warehousing_Fee_Information: 'Warehousing Fee Information',//仓储费信息
        Export: 'Export',//导出
        Warehouse_Name: 'Warehouse Name',//仓库名称
        Volume: 'Volume',//体积
        Product_Name: 'Product Name',//产品名称
        Inbound_Quantity: 'Inbound Quantity',//入库数量
        Quantity_in_Warehousing: 'Quantity in Warehousing',//仓储数量
        Single_Inbound_Fee: 'Single Inbound Fee',//单件入库费
        Warehousing_Fee_per_Unit: 'Warehousing Fee per Unit',//单件仓储费
        Current_Rental_Cycle_Start_Time: 'Current Rental Cycle Start Time (Inbound)',//入库本次收租周期时间
        Total_Cost_of_Warehousing: 'Total Cost of Warehousing-in',//入库总费用
        Total_Warehousing_Cost: 'Total Warehousing Cost',//仓储总费用
    }

}
